import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81bad26a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Events App")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Events List")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Create Event")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_7 = { style: {"margin-right":"5px"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Log out ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { color: "green" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar_title, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      (_ctx.loggedIn)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_btn, { to: { name: 'EventList' } }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _hoisted_3,
            _createVNode(_component_v_btn, { to: { name: 'EventCreate' } }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _hoisted_5
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_v_btn, { to: { name: 'about' } }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { vertical: "" }),
      (_ctx.loggedIn)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_v_spacer),
            _createElementVNode("div", _hoisted_7, "Hello, " + _toDisplayString(_ctx.userState.userInfo.name), 1),
            _createVNode(_component_v_btn, { onClick: _ctx.logout }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ], 64))
        : (_openBlock(), _createBlock(_component_v_btn, {
            key: 2,
            to: { name: 'Login' }
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}